import { render, staticRenderFns } from "./CabeceraModalSim.vue?vue&type=template&id=ce1696bc&scoped=true&"
import script from "./CabeceraModalSim.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalSim.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalSim.vue?vue&type=style&index=0&id=ce1696bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1696bc",
  null
  
)

export default component.exports